import { Layout, Row, Col, Typography } from 'antd';
import { t } from '@/utils/translator';
const { Title } = Typography;
const { Footer: AntFooter } = Layout;

function Footer() {
  return (
    <AntFooter className="bg-gray-7 text-light" style={{ textAlign: 'right' }}>
      <Row>
        <Col xs={12} md={12}>
          <div className="text-start">
            <Title level={5} className="text-light fs-6 fw-medium mb-1">
              (주)퀀티파이드이에스지
            </Title>
            <p className="fw-light mb-0">대표. 배익현 | 사업자등록번호. 349-86-01679</p>
            <p className="fw-light mb-0">문의. 02-6956-2410 (평일 09:00~17:00, 주말공휴일 휴무)</p>
            <p className="fw-light mb-0">
              주소. 서울특별시 종로구 새문안로3길 12 (신문로1가, 신문로빌딩), 3층 퀀티파이드이에스지
            </p>
          </div>
        </Col>
        <Col xs={12} md={12}>
          <div className="d-flex flex-column mb-3 h-100">
            <div className="d-flex mt-auto mb-2 ms-auto">
              <div> {t('개인정보 처리방침')}</div>
              <span className="mx-2">|</span>
              <div>{t('이용약관')}</div>
              <span className="mx-2">|</span>
              <div>{t('시스템 문의')}</div>
            </div>
            <div className="fw-light">Copyright 2025 QuantifiedESG, Inc. | All Rights Reserved</div>
          </div>
        </Col>
      </Row>
    </AntFooter>
  );
}

export default Footer;
